import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Stack, Text, IconButton, Modal, ScreenWidthMinXLarge, ScreenWidthMinLarge } from '@fluentui/react';
import PropTypes from 'prop-types';
import { NeutralColors } from '@fluentui/theme';
import { useSelector } from 'react-redux';
const modalContentItemsTokens = {
    childrenGap: 20
};
const cancelIcon = {
    iconName: 'Cancel'
};
const iconButtonStyles = {
    root: {
        color: NeutralColors.gray160
    }
};
const modalStyles = {
    main: {
        [`@media (min-width: ${ScreenWidthMinXLarge}px)`]: {
            width: '35%'
        },
        [`@media (min-width: ${ScreenWidthMinLarge}px) and (max-width: ${ScreenWidthMinXLarge}px)`]: {
            width: '60%'
        },
        [`@media (max-width: ${ScreenWidthMinLarge}px)`]: {
            width: '90%'
        },
        display: 'flex'
    },
    scrollableContent: {
        padding: '16px 27px 24px 24px',
        [`@media (max-width: ${ScreenWidthMinLarge}px)`]: {
            padding: '16px 20px 24px 20px'
        }
    }
};
export const ConsentModalContent = ({ showAnimation, handoffTitle, isTransactApp, isContactForm, publisher, shouldSkipModal, dismissModal, children }, context)=>{
    const isEmbedded = useSelector((state)=>state.config.isEmbedded);
    const withAnimationHeaderText = isContactForm ? context.locParams('TRY_ContactMe', [
        publisher || 'the publisher'
    ], `Sending your request to ${[
        publisher || 'the publisher'
    ]}`) : context.locParams('TRY_Redirect', [
        handoffTitle || 'Azure Portal'
    ], `Taking you to ${[
        handoffTitle || 'Azure Portal'
    ]} to complete this process`);
    const headerText = isEmbedded && !isContactForm ? context.loc('Confirm_to_continue_Modal_Title', 'Confirm to continue') : !isTransactApp && !isContactForm ? context.loc('Confirm_Details_Modal_Title', 'Confirm your details to continue') : isContactForm ? context.locParams('Contact_Me_Modal_Title', [
        publisher
    ], `Ask someone from ${publisher} to contact you`) : null;
    return /*#__PURE__*/ _jsx(Modal, {
        isOpen: !shouldSkipModal,
        onDismiss: dismissModal,
        styles: modalStyles,
        children: /*#__PURE__*/ _jsxs(Stack, {
            tokens: modalContentItemsTokens,
            children: [
                /*#__PURE__*/ _jsx(Stack.Item, {
                    children: /*#__PURE__*/ _jsxs(Stack, {
                        horizontal: true,
                        children: [
                            /*#__PURE__*/ _jsx(Stack.Item, {
                                grow: true,
                                children: showAnimation ? /*#__PURE__*/ _jsx(Text, {
                                    variant: "xLarge",
                                    children: withAnimationHeaderText
                                }) : /*#__PURE__*/ _jsx(Text, {
                                    variant: "xLarge",
                                    children: headerText
                                })
                            }),
                            /*#__PURE__*/ _jsx(Stack.Item, {
                                children: /*#__PURE__*/ _jsx(IconButton, {
                                    styles: iconButtonStyles,
                                    iconProps: cancelIcon,
                                    ariaLabel: context.loc('Dialog_Close', 'Close'),
                                    onClick: dismissModal
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx(Stack.Item, {
                    children: children
                })
            ]
        })
    });
};
ConsentModalContent.contextTypes = {
    loc: PropTypes.func,
    locParams: PropTypes.func,
    renderErrorModal: PropTypes.func,
    buildHref: PropTypes.func
};
